<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare :content='content' :padding='false'></SmallSquare>
      <div class="m-t-20 m-b-20 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:scanBackAdd="()=> {$router.push('/qrcode/scanBack/create?type=add')}">
              <PlusOutlined />
              添加黑名单
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'15px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="时间" name='time'>
          
               <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD  ' @change="onChange"    v-model:value="time"  />
        </a-form-item>
        <a-form-item label="会员信息" name='member_keyword'>
          <a-input v-model:value="search.member_keyword" style="width:250px" placeholder="请输入微信昵称/ID进行搜索"  allowClear />
        </a-form-item>
        <a-form-item label="有效期" name='blacklist_type'>
          <a-select v-model:value="search.blacklist_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="0">永久拉黑</a-select-option>
            <a-select-option :value="1">限时拉黑</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class="mb15">
        <span class='mr15' v-has:scanBackAllDel='batchRelease'>
          <a-button type="primary">
            批量撤销黑名单
          </a-button>
        </span>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey='id' :columns='columns' :data-source='data' class="tableFixBox">
        <template v-slot:status="{ record }">
          <p>{{record.status?'正常':'禁用'}}</p>
        </template>
        <template v-slot:time="{ record }">
          <p>{{record.start_time}}至</p>
          <p>{{record.end_time}}</p>
        </template>
        <template v-slot:member="{ record }">
          <p>{{record.member_name|| '暂无'}}</p>
          <p>(id:{{record.member_id}})</p>
        </template>
        <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:scanBackDel="()=>open(record)">撤销</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, h, createVNode } from "vue";
import { message } from "ant-design-vue";
import { blacklists, openForbids } from "@/api/qrcode";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  member_keyword: "",
  blacklist_type: "",
  start_time: "",
  end_time: ""
};
export default {
  components: { PlusOutlined },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      visibleInvite: false,
      visibleUrl: false,
      listId: [],
      listLoading: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      content:
        "黑名单上的用户将无法扫码查询防伪信息和参与扫码活动，黑名单身份可撤销。",
    });
    let columns = [
      {
        title: "会员信息",
        dataIndex: "member",
        key: "member",
        slots: { customRender: "member" },
      },
      {
        title: "时间",
        dataIndex: "time",
        key: "time",
        slots: { customRender: "time" },
      },
      {
        title: "有效期",
        dataIndex: "blacklist_limit",
        key: "blacklist_limit",
        customRender: ({ record }) => {
          return record.blacklist_limit == 0
            ? "永久"
            : record.blacklist_limit + "小时";
        },
      },
      {
        title: "原因",
        dataIndex: "remarks",
        key: "remarks",
      },
      {
        title: "释放时间",
        dataIndex: "releasing_time",
        key: "releasing_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
    const initData = async () => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await blacklists(search.value).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const batchRelease = () => {
      if (!state.selectedRowKeys.length) {
        message.error("请选择会员");
        return;
      }
      $Modal.confirm({
        centered: true,
        content: `您确定要将选中的撤销黑名单`,
        onOk: async () => {
          let result = await openForbids({ ids: state.selectedRowKeys })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            pageSearchChange();
          }
        },
      });
    };
    const open = async (data) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要撤销黑名单吗？`,
        onOk: async () => {
          let result = await openForbids({ ids: [data.id] })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            pageSearchChange();
          }
        },
      });
      
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      onSelectChange,
      batchRelease,
      open,
    };
  },
};
</script>